export class NavigationText {
    public static readonly RETURN_TO_GRID = 'Return to Grid';
    public static readonly SAVE = 'Save Changes';
    public static readonly CANCEL = 'Cancel';
    public static readonly NEXT = 'Next';
    public static readonly SAVE_AND_CLOSE = 'Save & Close';
    public static readonly SAVE_AND_RETURN = 'Save & Return';
    public static readonly RETURN = 'Return';
    public static readonly PREVIOUS = 'Previous';
    public static readonly HANDOVER_TO_EWA = 'Hand Over to EWA';
    public static readonly FINISH = 'Finish';
    public static readonly DELETE = 'Delete';
    public static readonly UPDATE_TEMPLATE_INFO = 'Update Template Info';
    public static readonly TOOLS_MENU = 'Tools';
    public static readonly CREATE_TEMPLATE = 'Create Template';
    public static readonly CEVO_TOOLS = 'Cevo® Tools';
    public static readonly CALL_SIGN_SEARCH = 'Call Sign Search';
    public static readonly HAAT_AND_MAX_ERP_CALCULATOR = 'Elev., HAAT, Max ERP';
    public static readonly DISTANCE_CONVERSION = 'Distance Conversion';
    public static readonly COORDINATE = 'Coordinate';
    public static readonly SUBMIT_FOR_COORDINATION = 'Submit for Coordination';
    public static readonly SUBMIT_MENU = 'Submit';
    public static readonly SUBMIT_TO_FCC = 'Submit to FCC';
    public static readonly SUBMIT_TO_PSCA = 'Submit to PSCA';
    public static readonly SUBMIT_TO_5_DAY_HOLD = 'Submit to 5 Day Hold';
    public static readonly GO_CONFIRM_TECHNICAL_DATA = 'Confirm Technical Data';
    public static readonly GO_CONFIRM_ORDER = 'Confirm Order';
    public static readonly GO_RE_RUN_COORDINATION = 'Re-run';
    public static readonly CONTACT_EWA_FOR_ASSISTANCE =
        'Contact EWA for Assistance';
    public static readonly SAVE_CHANGES = 'Save Changes';
    public static readonly PRINT = 'Print';
    public static readonly PRINT_INVOICE = 'Print Invoice';
    public static readonly PRINT_RECEIPT = 'Print Receipt';
    public static readonly PAYMENT = 'Payment';
    public static readonly RETURN_TO_ORDER = 'Return to Order';
    public static readonly BACK_TO_DASHBOARD = 'Back to Dashboard';
}
